import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, Overline } from "./primitives";
import { IMAGES } from "./content";

export default function Founder() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section data-testid="founder-section" className="relative bg-stone py-28 md:py-40">
      <div className="mx-auto grid max-w-[1600px] grid-cols-1 gap-14 px-6 md:grid-cols-12 md:gap-20 md:px-12">
        <div ref={ref} className="md:col-span-5">
          <div className="clip-frame relative aspect-[4/5] overflow-hidden">
            <motion.img
              style={{ y }}
              src={IMAGES.founder}
              alt="Founder of Epeeka Studio"
              loading="lazy"
              className="absolute inset-0 h-[122%] w-full object-cover"
            />
          </div>
        </div>

        <div className="flex flex-col justify-center md:col-span-7">
          <Reveal>
            <Overline className="text-copper">The Founder</Overline>
            <p className="mt-8 font-serif text-3xl leading-[1.25] text-ink sm:text-4xl lg:text-[2.9rem]">
              I grew up at my grandmother&apos;s house. I remember almost nothing about the
              finishes — and everything about how it{" "}
              <span className="italic text-forest">made us feel.</span>
            </p>
            <p className="mt-8 max-w-[52ch] leading-relaxed text-ink/65 md:text-lg">
              That house taught me the truth we build on today: a memorable home is made of
              feelings, not finishes. It is choreographed like boutique hospitality — every
              arrival, every gathering, every quiet morning designed with intention.
            </p>
            <p className="mt-6 max-w-[52ch] leading-relaxed text-ink/65 md:text-lg">
              We don&apos;t design houses. We create destinations that families organize their
              lives — and their legacies — around.
            </p>
            <p className="mt-10 font-serif text-2xl italic text-ink">Epeeka Moopanar</p>
            <span className="overline mt-2 block text-ink/40">Founder &amp; Principal</span>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
